import React from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { formatDateTime } from '../../utils/datetime';

interface PersonalVerificationDetailModalProps {
    isOpen: boolean;
    onClose: () => void;
    verificationDetailData: any;
}

const PersonalVerifictionDetailModal: React.FC<PersonalVerificationDetailModalProps> = ({ isOpen, onClose, verificationDetailData }) => {
    // const personalVerificationInfo = useSelector((state: RootState) => state.personalVerification);

    const { t } = useTranslation('verification');
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-left text-black">
                <span
                    className="close"
                    onClick={onClose}
                >
                    ×
                </span>
                <h2><i>{t('detail info')}</i></h2>
                { verificationDetailData && (
                  <div>
                      <p>
                          <strong>{t('id')} : </strong>
                          <span>{verificationDetailData.id}</span>
                      </p>
                      <p>
                          <strong>{t('public id')} : </strong>
                          <span>{verificationDetailData.publicId}</span>
                      </p>
                      <p>
                          <strong>{t('personal verification document')} : </strong>
                          <span>{t(verificationDetailData.personalVerificationDocument)}</span>
                      </p>
                      <p>
                          <strong>{t('personal verification method')} : </strong>
                          <span>{t(verificationDetailData.personalVerificationMethod)}</span>
                      </p>
                      <p>
                          <strong>{t('received datetime')} : </strong>
                          <span>{formatDateTime(verificationDetailData.receivedDate)}</span>
                      </p>
                      <p>
                          <strong>{t('updated datetime')} : </strong>
                          <span>{formatDateTime(verificationDetailData.updateDate)}</span>
                      </p>
                      <p>
                          <strong>{t('verified datetime')} : </strong>
                          <span>{formatDateTime(verificationDetailData.verificationDate)}</span>
                      </p>
                      <p>
                          <strong>{t('status')} : </strong>
                          <span>{t(verificationDetailData.state)}</span>
                      </p>
                      {verificationDetailData.result && (
                        <p>
                            <strong>{t('result')} : </strong>
                            <span>{t(verificationDetailData.result)}</span>
                        </p>
                      )}
                      {verificationDetailData.result === "denied" && (
                        <>
                            <p>
                                <strong>{t('reason')} : </strong>
                                <span>
                                        {t(verificationDetailData.reasonCode)}<br/>
                                    </span>
                            </p>
                        </>
                      )}
                      <br/>
                      <p>
                          <a href={`${process.env.REACT_APP_TRUSTDOCK_OPERATION_URL}/verification/inspections?verification_inspection_search%5Bverification_id%5D=${verificationDetailData.verificationId}&verification_inspection_search%5Bconditional_search%5D=0&verification_inspection_search%5Bmishandle_search%5D=0&commit=%E6%A4%9C%E7%B4%A2`} target="_blank"><strong>{t('ID Search')}</strong></a>
                      </p>
                  </div>
                )}
                <div className='flex flex-row justify-start'>
                    <div className='m-[10px]'>
                        <Button
                          label={t('close')}
                            onClick={onClose}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalVerifictionDetailModal;
